import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { useAuthCheck } from "./hooks/useAuthCheck";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./providers/ToastProvider";
import MainLayout from "./layouts/MainLayout";

//import HomePage from "./pages/HomePage";
import LoginForm from "./components/LoginForm";
import Profile from "./pages/ProfilePage";
import DashboardPage from "./pages/DashboardPage";
import ManageUsersPage from "./pages/ManageUsersPage";
import WorkflowPage from "./pages/WorkflowPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import CreateTowerPage from "./pages/CreateTowerPage";
import ProtectedRoute from "./utils/ProtectedRoute";
import CreateOpportunityPage from "./pages/CreateOpportunityPage";
import WhatsNewModal from "./components/modals/WhatsNewModal";
import useWhatsNewModal from "./utils/useWhatsNewModal";

function App() {
  const { isCheckingAuth, isAuthenticated } = useAuthCheck(["user.read"]);
  const location = useLocation();

  // Add What's New Modal functionality
  const { showModal, handleCloseModal, handleShowModal } = useWhatsNewModal();

  if (isCheckingAuth) {
    return <div>Checking authentication status...</div>;
  }

  return (
    <ToastProvider>
      <AuthProvider>
        <MainLayout>
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated ? <Navigate to="/dashboard" /> : <LoginForm />
              }
            />
            <Route
              path="/login"
              element={
                isAuthenticated ? <Navigate to="/dashboard" /> : <LoginForm />
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manageusers"
              element={
                <ProtectedRoute>
                  <ManageUsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workflow"
              element={
                <ProtectedRoute>
                  <WorkflowPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <AnalyticsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/createTower"
              element={
                <ProtectedRoute>
                  <CreateTowerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/createOpportunity"
              element={
                <ProtectedRoute>
                  <CreateOpportunityPage />
                </ProtectedRoute>
              }
            />
          </Routes>

          {/* What's New Modal */}
          <WhatsNewModal show={showModal} onHide={handleCloseModal} />

          {/* Optional: Button to manually show the modal again */}
          <button
            className="btn btn-info"
            onClick={handleShowModal}
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              zIndex: 1000,
            }}
          >
            Latest Updates
          </button>
        </MainLayout>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
